import Splide from "@splidejs/splide";
import { Intersection } from "@splidejs/splide-extension-intersection";

function initSliderDecoration(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-decoration").forEach((el) => {
		const splideDecoration = new Splide(el, {
			type: "slide",
			pagination: false,
			arrows: true,
			gap: "30px",
			perPage: 3,
			snap: true,
			interval: 3000,
			autoplay: "pause",
			pauseOnHover: true,
			intersection: {
				inView: {
					autoplay: true,
				},
				outView: {
					autoplay: false,
				},
			},
			speed: 700,
			focus: 0,
			omitEnd: true,
			breakpoints: {
				1100: { perPage: 2.5 },
				768: { perPage: 2.1, gap: "25px" },
				640: { perPage: 1.7, gap: "25px" },
				500: { perPage: 1.15, gap: "25px" },
			},
		});

		splideDecoration.mount({Intersection});

	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderDecoration());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-archive-slider-decoration", ($block) => {
		initSliderDecoration($block && $block.jquery ? $block.get(0) : $block);
	});
}
